import {connect} from 'react-redux';

import IngestConfigsContainer from './IngestConfigsContainer';
import {setIngestConfigsAction} from './Redux/IngestConfigsActions';
import {IngestSelectList} from './IngestConfigTypes';
import {IngestDataPayload} from '../IngestData/IngestDataTypes';

interface State {
    textEnums: {
        ingestConfigTypes: IngestSelectList;
        ingestConfigStatuses: IngestSelectList;
        labPartners: IngestSelectList;
    };
    ingest: {
        ingestConfigs: {
            rows: IngestDataPayload[];
            total: number;
        };
    };
}

export const mapState = (state: State) => {
    return {
        ingestTypes: state.textEnums.ingestConfigTypes,
        ingestStatuses: state.textEnums.ingestConfigStatuses,
        labPartners: state.textEnums.labPartners,
        ingestConfigs: state.ingest.ingestConfigs.rows,
        total: state.ingest.ingestConfigs.total,
    };
};

export const mapDispatch = {
    setIngestConfigs: setIngestConfigsAction,
};

export default connect(mapState, mapDispatch)(IngestConfigsContainer);
